import { render, staticRenderFns } from "./FieldLabel.vue?vue&type=template&id=3b3d1305&scoped=true&"
import script from "./FieldLabel.vue?vue&type=script&lang=js&"
export * from "./FieldLabel.vue?vue&type=script&lang=js&"
import style0 from "./FieldLabel.vue?vue&type=style&index=0&id=3b3d1305&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d1305",
  null
  
)

export default component.exports